import React, { useState } from 'react'

interface IconWrapperProps {
    icon: JSX.Element
    hoveredIcon?: JSX.Element
    className?: string
    onClick?: () => void
    alt?: string
}

const IconWrapper: React.FC<IconWrapperProps> = ({
    icon: Icon,
    hoveredIcon,
    className = '',
    onClick,
    alt,
}) => {
    const [isHovered, setIsHovered] = useState(false)

    return (
        <span
            className={`icon-wrapper ${onClick ? 'cursor-pointer' : ''} ${isHovered ? 'hovered' : ''} ${className}`}
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            role={onClick ? 'button' : undefined}
            aria-label={alt}
            style={{ display: 'inline-flex', alignItems: 'center' }}
        >
            { isHovered && hoveredIcon ? hoveredIcon : Icon }
        </span>
    )
}

export default IconWrapper
